export const PageSource = {
  PatientList: 'patient-list',
  PatientDashboard: 'patient-dashboard'
};
